<template>
  <div class="goodsDetail" id="DetailHeadUp">
    <div class="areaH2 changePanel">
      <button @click="prevDetail" class="_prev" area-label="前詳細ページ移動ボタン"><img :src="setImageFullPath('components/anyDetail/arrowLeft.svg')" alt="左向き矢印"></button>
      <h2 v-text="isDetail"></h2>
      <button @click="nextDetail" class="_next" area-label="次詳細ページ移動ボタン"><img :src="setImageFullPath('components/anyDetail/arrowRight.svg')" alt="右向き矢印"></button>
    </div>
    <div class="container">
      <div class="rowView spec">

				<template v-if="isEquipment">
<!--設備詳細 -->
					<div class="detail equipmentDetail">
						<div class="specPicture">
							<img-plus :img-src="detail.image" :img-poster="detail.thumb" :img-alt="detail.alt" :full-screen="true" />
						</div>
						<dl class="specText">
							<dt>工程</dt><dd>{{detail.process}}</dd>
							<dt>メーカー</dt><dd>{{detail.maker}}</dd>
							<dt>備考</dt><dd class="_remarks" v-text="detail.remarks"></dd>
							<dt>設置</dt><dd>{{detail.factory}}</dd>
							<dt>台数</dt><dd>{{detail.number}}</dd>
						</dl>
					</div>
				</template>

				<template v-else-if="isProducts">
<!--事例詳細 -->
					<div class="detail productsDetail">
						<div class="specPicture">
							<img-plus :img-src="detail.image" :img-poster="detail.thumb" :img-alt="detail.alt" :full-screen="true" />
						</div>
						<dl class="specText">
							<dt>作業内容</dt><dd>{{detail.process}}</dd>
							<dt>材質</dt><dd>{{detail.material}}</dd>
							<dt>板厚</dt><dd>{{detail.thickness}}</dd>
							<dt>サイズ</dt><dd>{{detail.size}}</dd>
							<dt>部品点数</dt><dd>{{detail.parts}}</dd>
							<dt>ロット</dt><dd>{{detail.quantity}}</dd>
							<dt>製作期間</dt><dd>{{detail.period}}</dd>
							<dt>製作費用</dt><dd>{{detail.budget}}</dd>
							<dt>納品日</dt><dd>{{isoDateToDisplayDate(detail.date)}}</dd>
							<dt>備考</dt><dd>{{detail.remarks}}</dd>
						</dl>
					</div>
				</template>

				<template v-else-if="isAnnounce">
<!--お知らせ詳細 -->
					<div class="detail announceDetail">
						<div class="specPicture">
							<img-plus :img-src="detail.image" :img-alt="detail.alt" :img-poster="detail.thumb" :full-screen="true" />
						</div>
						<div class="specText">
							<p class="_date">{{isoDateToDisplayDate(detail.date)}}</p>
							<p class="_note">wrote by {{detail.note}}</p>
							<p class="_content" v-text="detail.content"></p>
						</div>
						<div class="specLink">
		<p class="_link" v-if="isAnyLink(detail.link)" @mouseenter="addLinkIcon(detail.link, $event)" @mouseleave="deleteLinkIcon" @click.stop="toAnyPage(detail.link, detail.landing)">関連リンク：{{detail.label}}</p>
						</div>
					</div>
				</template>

				<template v-else >
<!--?詳細 -->
					<div class="">
					</div>
				</template>

        <component :is="plusInformation"></component>
      </div>
    </div>

  </div>
</template>

<script>
import imgPlus from '@/components/ImgPlus.vue'

//import fileA from '@/views/products/detail/GoodsA.vue'
//import fileB from '@/views/products/detail/GoodsB.vue'
//import fileC from '@/views/products/detail/GoodsC.vue'

//let plusInformation = "plusA"
export default {
  name: 'listDetail',
  components: {
    'imgPlus':imgPlus,
/*
    'plusA':fileA,
    'plusB':fileB,
    'plusC':fileC,
*/
  },
  props: {
		anyList:{
			type:Number,
		},
		detail:{
			type:Object,
		},
	},
  data() {
    return {
      plusInformation:"",
			pageTitle:'',
			description:'',
			keywords:"",
			ogType:"article",
    }
  },
  computed: {
		isEquipment:function() {
			return this.anyList === 1
		},
		isProducts:function() {
			return this.anyList === 2
		},
		isAnnounce:function() {
			return this.anyList === 3
		},
		isDetail:function() {
			return this.detail == undefined?"":this.detail.title
		},
	},
  mounted: function() {console.log("mounted "+this.$options.name)

    this.$store.commit('updatePageSectionInfo', this.gatherTagId())
    this.$store.commit('updatePageBackgroundStyle', '')

	/*head情報をセットする*/
		this.$store.commit('updateCurrentTitle', this.detail.title)
		this.$store.commit('updateCurrentDescription', this.detail.title)
		this.$store.commit('updateCurrentKeywords', this.keywords)
		this.$store.commit('updateCurrentOgUrl', this.isUrl)
		this.$store.commit('updateCurrentOgType', this.setOgType())
		this.$store.commit('updateCurrentOgDesc', this.description)
		this.$store.commit('updateLinkCanonical', '')

		this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())

    this.plusInformation = this.isPlusInformation(this.detail.filename)

//PC表示の場合、ヘッダ部分スクロールする
//"DetailHeadUpSp "親での設定が必須
		if( this.checkWidthSize()) {
			this.changePageScrollAnyAnchor("DetailHeadUp")
		} else {
			this.changePageScrollAnyAnchor("DetailHeadUpSp")
		}
  },
  beforeUpdate:function() {console.log("beforeUpdate "+this.$options.name)



	},
  updated: function() {console.log("updated "+this.$options.name)
    this.$store.commit('updatePageSectionInfo', this.gatherTagId())
    this.$store.commit('updatePageBackgroundStyle', '')

	/*head情報をセットする*/
		this.$store.commit('updateCurrentTitle', this.detail.title)
		this.$store.commit('updateCurrentDescription', this.detail.title)
		this.$store.commit('updateCurrentKeywords', this.keywords)
		this.$store.commit('updateCurrentOgUrl', this.isUrl)
		this.$store.commit('updateCurrentOgType', this.setOgType())
		this.$store.commit('updateCurrentOgDesc', this.description)
		this.$store.commit('updateLinkCanonical', '')

		this.$store.commit('updateLdJsonBreadcrumb', this.makeBreadcrumbList())

//詳細ファイル名をセットする
    this.plusInformation = this.isPlusInformation(this.detail.filename)

//PC表示の場合、ヘッダ部分スクロールする
		if( this.checkWidthSize()) {
			this.changePageScrollAnyAnchor("DetailHeadUp")
		} else {
			this.changePageScrollAnyAnchor("DetailHeadUpSp")
		}
  },
  methods:{
    prevDetail:function() {
      this.$emit('changeDetail', -1)
    },
    nextDetail:function() {
      this.$emit('changeDetail', 1)
    },
    isPlusInformation:function(aFile) {
       return (aFile === undefined)? '':"plus" + this.detail.filename
    },
		setOgType:function() {
			return (this.anyList === 2)? 'product':'article'
		},
	},
}
</script>

<style>
</style>